import React from 'react'
import { Card, Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { HiLocationMarker } from 'react-icons/hi';
import { ImUsers } from 'react-icons/im';
import { FaUsers } from 'react-icons/fa';
import { GrDocumentVerified } from 'react-icons/gr';
import { FaBuilding } from 'react-icons/fa';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import CountUp from 'react-countup';
import Clients from './Clients';
import Accordion from 'react-bootstrap/Accordion';
import { BiUser } from 'react-icons/bi';
export default function Service() {
    return (
        <>
            <section className='banner_strip'>
            <h1>Service</h1>
            </section>
            <section className='section'>
                    <Container fluid>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Service</li>
                        </ol>
                    </nav>
                    </Container>
                    <Container fluid>
                        <Row>
                            <Col lg={6}>
                                <div className='solution-box'>
                                    <h5 className='sub-heading'>Service apprenticeshipwale </h5>
                                    <h1 className='title-heading'>
                                        Dedicated Solutions with
                                        25 Years Experience
                                    </h1>
                                    <p>Entrepreneurs, artist, athletes and other individuals who have excelled in their field share fun and inspiring stories from their journey to success.</p>
                                    <ul>

                                        <li>
                                            <img src={require('../assets/images/icon3.png')} alt="icon3" />
                                        </li>
                                        <li>
                                            <img src={require('../assets/images/icon4.png')} alt="icon4" />
                                        </li>
                                        <li>
                                            <img src={require('../assets/images/icon5.png')} alt="icon5" />
                                        </li>
                                    </ul>
                                    <a href="#" className='kn_btn'>Know More</a>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className='right-img-box'>
                                    <div className='img-b'>
                                        <img src={require('../assets/images/img1.jpg')} alt="img1" />
                                    </div>
                                    <div className='img-b'>
                                        <img src={require('../assets/images/img.jpg')} alt="img" />
                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            <div className='job-page about-page'>


                <div className=''>
                    <Container fluid>
                        <Row>
                            <Col lg={12} xs={12}>
                                <h1 className='text-center title-heading op_heading mb-4 color-dark'>Service</h1>
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={6}>
                                <Card className='service-box'>
                                    <div className='company-icon'>
                                        <BiUser />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Awesome Support</h4>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa culpa ea suscipit animi, reprehenderit incidunt nostrum voluptas</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={6}>
                                <Card className='service-box'>
                                    <div className='company-icon'>
                                        <BiUser />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Awesome Support</h4>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa culpa ea suscipit animi, reprehenderit incidunt nostrum voluptas</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={6}>
                                <Card className='service-box'>
                                    <div className='company-icon'>
                                        <BiUser />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Awesome Support</h4>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa culpa ea suscipit animi, reprehenderit incidunt nostrum voluptas</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={6}>
                                <Card className='service-box'>
                                    <div className='company-icon'>
                                        <BiUser />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Awesome Support</h4>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa culpa ea suscipit animi, reprehenderit incidunt nostrum voluptas</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={6}>
                                <Card className='service-box'>
                                    <div className='company-icon'>
                                        <BiUser />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Awesome Support</h4>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa culpa ea suscipit animi, reprehenderit incidunt nostrum voluptas</p>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={6}>
                                <Card className='service-box'>
                                    <div className='company-icon'>
                                        <BiUser />
                                    </div>
                                    <div className='service-content'>
                                        <h4>Awesome Support</h4>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa culpa ea suscipit animi, reprehenderit incidunt nostrum voluptas</p>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <section className='section-1 section'>
                    <h1 className='title-heading op_heading mb-4'>Service Information</h1>

                    <Row>
                    <Col md={6}>
                            <div className='img-common-box'>
                                <img src='https://template.hasthemes.com/keller/keller/assets/images/others/about-1.jpg' />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className='box-layout'>

                                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Numquam eius, cumque eaque iste amet deleniti repudiandae debitis consequatur, vel, non nulla autem sequi qui accusamus? Tempore pariatur deleniti voluptas quas porro incidunt id, doloremque quidem at fugiat neque soluta temporibus!</p>
                                <ul>
                                    <li>Lorem ipsum, dolor sit amet</li>
                                    <li>Consectetur adipisicing elit</li>
                                    <li>Numquam eius, cumque eaque iste</li>
                                    <li>Amet deleniti repudiandae debitis consequatur</li>
                                    <li>Tempore pariatur deleniti voluptas</li>
                                </ul>
                            </div>
                        </Col>

                    </Row>
                </section>

            </div>
            <div className='bg-white'>
                <Clients />
            </div>
        </>
    )
}

